import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Badge } from "reactstrap";
import {
  getEpisodeByEmission,
  getDraftForEpisode,
} from "@store/action/planning/EpisodeAction";
import { getPodacstForEmission } from "@store/action/planning/EmissionAction";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { store } from "@store/StoreConfig";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { BsMusicNoteList } from "react-icons/bs";
import { activeThreeDots } from "@src/@core/components/tuneIn/main.js";
import { BsCalendarDate } from "react-icons/bs";
import { BiTimeFive } from "react-icons/bi";
import ReactPaginate from "react-paginate";

const API = process.env.REACT_APP_MICRO_PLANING_URL;

let data = {
  currentsong: null,
  download: null,
};

const TabsCentered = ({ t }) => {
  activeThreeDots();
  const [active, setActive] = useState("1");
  const [status, setStatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const episodes = useSelector((state) => state.episodes);
  const episode = episodes && episodes?.episodesByEmission;
  const emissions = useSelector((state) => state.emissions);
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const podcastList = emissions && emissions.podcastList;
  const podcastListLength =
    podcastList && podcastList.length
      ? podcastList && podcastList[0].length
      : 0;
  const EpisodeListLength =
    episode && episode.length ? episode && episode[0].length : 0;
  const id = useParams().id;
  const dispatch = useDispatch();
  const getAvenir = () => {
    dispatch(getEpisodeByEmission(status, id));
  };
  const toggle = (tab) => {
    if (active !== tab) {
      setActive(tab);
    }
  };
  useEffect(() => {
    dispatch(getPodacstForEmission(id));
    dispatch(getEpisodeByEmission(status, id));
    dispatch(
      getDraftForEpisode(id, {
        page: currentPage,
      })
    );
  }, [dispatch, id, currentPage]);
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };
  const count = episodes.draft_episode.total;
  const formatDate = (date) => {
    let intitalDate = new Date(date);
    return (
      <>
        <BsCalendarDate style={{ margin: "5px" }} />
        {`${intitalDate.getDay()}/${
          intitalDate.getMonth() + 1
        }/${intitalDate.getFullYear()}`}
        <BiTimeFive style={{ margin: "5px" }} />
        {`${intitalDate.getHours()}:${intitalDate.getMinutes()}:${intitalDate.getSeconds()}`}
      </>
    );
  };
  const renderPodcastList = () =>
    podcastList &&
    podcastList[0]?.map((item, i) => (
      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12" key={i}>
        <div className="top_songs_list free_music_wrapper ms_cover">
          <div className="top_songs_list_left">
            <div className="treanding_slider_main_box top_lis_left_content">
              <div className="top_songs_list0img">
                <img height="50px" src={emissions.em?.picture} alt="img" />
                <div className="ms_treanding_box_overlay">
                  <div className="ms_tranding_box_overlay" />
                  <div className="tranding_play_icon">
                    {PlayerFrontOfficeReducer.currentSong === item.file_path ? (
                      <BsMusicNoteList color="#7367F0" size={20} />
                    ) : (
                      <a
                        onClick={() =>
                          store.dispatch(
                            addMusic(
                              (data = {
                                currentsong: item.file_path,
                                download: `${API}/podcast/download/${item.id}`,
                                namesong: `${item.name}`,
                                songimg: emissions.em?.picture,
                                item_data: item,
                                has_video: item.name.endsWith("mp4") && true,
                                is_web_rtc: false,
                              })
                            )
                          )
                        }
                      >
                        <i className="flaticon-play-button" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="release_content_artist top_list_content_artist">
                <p>
                  <Link to={`/podcast/${item.id}`}>Title: {item.name}</Link>
                </p>
                <p className="various_artist_text">
                  <a>episode type: Live</a>
                </p>
              </div>
            </div>
            <div className="top_list_tract_time">
              <p>{item.record_datetime}</p>
            </div>
          </div>
          <div className="top_songs_list_right">
            <div className="top_song_list_picks">
              <div className="ms_tranding_more_icon">
                <i className="flaticon-menu" />
              </div>
              <ul className="tranding_more_option">
                <li>
                  <a href="#">
                    <span className="opt_icon">
                      <i className="flaticon-playlist" />
                    </span>
                    Add To playlist
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="opt_icon">
                      <i className="flaticon-star" />
                    </span>
                    favourite
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="opt_icon">
                      <i className="flaticon-share" />
                    </span>
                    {t("share")}
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="opt_icon">
                      <i className="flaticon-download" />
                    </span>
                    {t("download now")}
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="opt_icon">
                      <i className="flaticon-trash" />
                    </span>
                    {t("delete")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    ));
  const renderEpisodeList = () => {
    return (
      episode &&
      episode[0]?.map((item, i) => (
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 pd1" key={i}>
          <div className="treanding_slider_main_box release_box_main_content ms_cover">
            <div className="release_content_artist">
              <p>
                <a>
                  {" "}
                  {t("Episode")}: {item.name}
                </a>
              </p>
              <p className="various_artist_text">
                <a>
                  {t("Emission")}: {emissions.em?.name}
                </a>
              </p>
              <p className="various_artist_text">
                <a>{formatDate(item.created_at)}</a>
              </p>
              <p className="various_artist_text">
                <Link
                  to={`/episode/classification/${item.classification?.id}/${item?.classification?.name}`}
                >
                  {t("Classification")} : {item?.classification?.name}
                </Link>
              </p>

              {item?.categories.length ? (
                <p
                  className="various_artist_text"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  <span>
                    <a>{t("categorys")}:</a>
                    {item.categories.map((ele, i) => (
                      <Link key={i} to={`/episode/category/${ele.slug}`}>
                        <Badge style={{ margin: "2px" }} color="light-warning">
                          {ele.name}
                        </Badge>
                      </Link>
                    ))}
                  </span>
                </p>
              ) : (
                ""
              )}
              {item?.tags.length ? (
                <p
                  className="various_artist_text"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  <span>
                    <a>tags:</a>
                    {item.tags.map((ele, i) => (
                      <Link key={i} to={`/episode/tag/${ele.slug}`}>
                        <Badge style={{ margin: "2px" }} color="">
                          #{ele.name}
                        </Badge>
                      </Link>
                    ))}
                  </span>
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      ))
    );
  };
  const renderDraftList = () =>
    episodes.draft_episode &&
    episodes.draft_episode?.data?.map((item, i) => (
      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12" key={i}>
        <div className="top_songs_list free_music_wrapper ms_cover">
          <div className="top_songs_list_left">
            <div className="treanding_slider_main_box top_lis_left_content">
              <div className="top_songs_list0img">
                <img height="150px" src={emissions.em?.picture} alt="img" />
              </div>

              <div className="release_content_artist top_list_content_artist">
                <p>
                  <a>
                    {" "}
                    {t("Episode")}: {item.name}
                  </a>
                </p>
                <p className="various_artist_text">
                  <a>
                    {t("Emission")}: {emissions.em?.name}
                  </a>
                </p>
                <p className="various_artist_text">
                  <a>{formatDate(item.created_at)}</a>
                </p>
                <p className="various_artist_text">
                  <Link
                    to={`/episode/classification/${item.classification?.id}/${item?.classification?.name}`}
                  >
                    {t("Classification")} : {item?.classification?.name}
                  </Link>
                </p>

                {item?.categories.length ? (
                  <p
                    className="various_artist_text"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>
                      <a>{t("categorys")}:</a>
                      {item.categories.map((ele, i) => (
                        <Link key={i} to={`/episode/category/${ele.slug}`}>
                          <Badge
                            style={{ margin: "2px" }}
                            color="light-warning"
                          >
                            {ele.name}
                          </Badge>
                        </Link>
                      ))}
                    </span>
                  </p>
                ) : (
                  ""
                )}
                {item?.tags.length ? (
                  <p
                    className="various_artist_text"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>
                      <a>{t("Tags")}:</a>
                      {item.tags.map((ele, i) => (
                        <Link key={i} to={`/episode/tag/${ele.slug}`}>
                          <Badge style={{ margin: "2px" }} color="">
                            #{ele.name}
                          </Badge>
                        </Link>
                      ))}
                    </span>
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="top_list_tract_time">
              <p>{item.record_datetime}</p>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="podcast-nav-bav">
      <Nav className="justify-content-center" tabs>
        <NavItem>
          <NavLink
            active={active === "1"}
            onClick={() => {
              toggle("1");
            }}
          >
            {t("Podcast")}( {podcastListLength} )
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === "2"}
            onClick={() => {
              toggle("2");
              getAvenir();
            }}
          >
            {t("Coming")}({EpisodeListLength})
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === "3"}
            onClick={() => {
              toggle("3");
            }}
          >
            {t("Draft")}({episodes.draft_episode.total})
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent className="py-50" activeTab={active}>
        <TabPane tabId="1">
          <div className="row">{renderPodcastList()} </div>
        </TabPane>
        <TabPane tabId="2">
          <div className="row"> {renderEpisodeList()} </div>
        </TabPane>
        <TabPane tabId="3">
          <div className="row"> {renderDraftList()} </div>
          <div className="blog_pagination_section ms_cover">
            <ReactPaginate
              previousLabel={
                <p className="prev">
                  <i className="flaticon-left-arrow" />
                </p>
              }
              nextLabel={
                <p className="next">
                  <i className="flaticon-right-arrow" />
                </p>
              }
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={count || 1}
              breakLabel="..."
              activeClassName="third_pagger"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              onPageChange={(page) => handlePageChange(page)}
              pageClassName={"page-item"}
              containerClassName={
                "pagination react-paginate justify-content-end p-1"
              }
            />
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
};
export default TabsCentered;
